const Icons = {
    Layout: () => (
        <svg viewBox="0 0 20 20" className="Polaris-Icon__Svg" focusable="false" aria-hidden="true"><path fillRule="evenodd" d="M3.5 5.25c0-.966.784-1.75 1.75-1.75h9.5c.966 0 1.75.784 1.75 1.75v1.5a1.75 1.75 0 0 1-1.75 1.75h-9.5a1.75 1.75 0 0 1-1.75-1.75v-1.5Zm1.75-.25a.25.25 0 0 0-.25.25v1.5c0 .138.112.25.25.25h9.5a.25.25 0 0 0 .25-.25v-1.5a.25.25 0 0 0-.25-.25h-9.5Z"></path><path d="M3.5 11.25c0-.966.784-1.75 1.75-1.75h.5a.75.75 0 0 1 0 1.5h-.5a.25.25 0 0 0-.25.25v.5a.75.75 0 0 1-1.5 0v-.5Z"></path><path d="M3.5 14.75c0 .966.784 1.75 1.75 1.75h.5a.75.75 0 0 0 0-1.5h-.5a.25.25 0 0 1-.25-.25v-.5a.75.75 0 0 0-1.5 0v.5Z"></path><path d="M14.75 9.5c.966 0 1.75.784 1.75 1.75v.5a.75.75 0 0 1-1.5 0v-.5a.25.25 0 0 0-.25-.25h-.5a.75.75 0 0 1 0-1.5h.5Z"></path><path d="M14.75 16.5a1.75 1.75 0 0 0 1.75-1.75v-.5a.75.75 0 0 0-1.5 0v.5a.25.25 0 0 1-.25.25h-.5a.75.75 0 0 0 0 1.5h.5Z"></path><path d="M11.75 10.25a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1 0-1.5h2a.75.75 0 0 1 .75.75Z"></path><path d="M11 16.5a.75.75 0 0 0 0-1.5h-2a.75.75 0 0 0 0 1.5h2Z"></path></svg>
    ),
    Block: () => (
        <svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true"><path d="M5 6.25c0-.69.56-1.25 1.25-1.25h2a.75.75 0 0 0 0-1.5h-2a2.75 2.75 0 0 0-2.75 2.75v2a.75.75 0 0 0 1.5 0v-2Z"></path><path d="M13.75 5c.69 0 1.25.56 1.25 1.25v2a.75.75 0 0 0 1.5 0v-2a2.75 2.75 0 0 0-2.75-2.75h-2a.75.75 0 0 0 0 1.5h2Z"></path><path d="M13.75 15c.69 0 1.25-.56 1.25-1.25v-2a.75.75 0 0 1 1.5 0v2a2.75 2.75 0 0 1-2.75 2.75h-2a.75.75 0 0 1 0-1.5h2Z"></path><path d="M6.25 15c-.69 0-1.25-.56-1.25-1.25v-2a.75.75 0 0 0-1.5 0v2a2.75 2.75 0 0 0 2.75 2.75h2a.75.75 0 0 0 0-1.5h-2Z"></path></svg>
    ),
    Plus: () => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20" fill="#FFFFFF"><path d="M10.75 5.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.5h-3.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.5v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5h3.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.5v-3.5Z" /></svg>
    ),
    MoveUp: () => (
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" focusable="false"><path d="M18 16a.75.75 0 0 1-.75.75h-6.5a.75.75 0 0 1 0-1.5h6.5A.75.75 0 0 1 18 16ZM18 7a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h4.5A.75.75 0 0 1 18 7ZM4.53 8.28a.75.75 0 1 1-1.06-1.06l2.5-2.5a.75.75 0 0 1 1.06 0l2.5 2.5a.75.75 0 0 1-1.06 1.06L7.25 7.06V8.5a2.25 2.25 0 0 0 2.25 2.25h7.75a.75.75 0 0 1 0 1.5H9.5A3.75 3.75 0 0 1 5.75 8.5V7.06L4.53 8.28Z"></path></svg>
    ),
    MoveDown: () => (
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" focusable="false"><path fillRule="evenodd" clipRule="evenodd" d="M2 5.25a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 2 5.25Zm0 9a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Zm14.53-1.28a.75.75 0 0 0-1.06 0l-1.22 1.22v-1.44A3.75 3.75 0 0 0 10.5 9H2.75a.75.75 0 0 0 0 1.5h7.75a2.25 2.25 0 0 1 2.25 2.25v1.44l-1.22-1.22a.75.75 0 1 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l2.5-2.5a.75.75 0 0 0 0-1.06Z"></path></svg>
    ),
    View: () => (
        <svg className="wh-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M9.977 2.751a7.6 7.6 0 0 0-1.977-.251c-2.444 0-4.196 1.045-5.325 2.233a7.2 7.2 0 0 0-1.243 1.773c-.26.532-.432 1.076-.432 1.494s.171.962.432 1.494c.172.353.4.733.687 1.115l1.074-1.074a5 5 0 0 1-.414-.7c-.221-.453-.279-.753-.279-.835s.058-.382.279-.835a5.7 5.7 0 0 1 .983-1.398c.89-.937 2.264-1.767 4.238-1.767q.36 0 .693.036z"></path><path fillRule="evenodd" d="M2.25 12.6a.75.75 0 0 0 1.067 1.053l1.062-1.061c.975.543 2.177.908 3.621.908 2.45 0 4.142-1.05 5.24-2.242 1.078-1.17 1.588-2.476 1.738-3.076a.75.75 0 0 0 0-.364c-.15-.6-.66-1.906-1.738-3.076a7 7 0 0 0-.51-.502l.923-.923a.749.749 0 0 0-1.053-1.068l-.008.008-10.335 10.336zm5.75-.6c-.978 0-1.809-.204-2.506-.523l1.108-1.109a2.75 2.75 0 0 0 3.767-3.766l1.298-1.299q.254.221.47.455a6.4 6.4 0 0 1 1.332 2.242 6.4 6.4 0 0 1-1.332 2.242c-.86.933-2.17 1.758-4.137 1.758m0-2.75q-.13-.001-.254-.026l1.478-1.478a1.25 1.25 0 0 1-1.224 1.504"></path></svg>
    ),
    Delete: () => (
        <svg className="wh-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M9.5 6.25a.75.75 0 0 1 .75.75v4.25a.75.75 0 0 1-1.5 0v-4.25a.75.75 0 0 1 .75-.75"></path><path d="M7.25 7a.75.75 0 0 0-1.5 0v4.25a.75.75 0 0 0 1.5 0z"></path><path fillRule="evenodd" d="M5.25 3.25a2.75 2.75 0 1 1 5.5 0h3a.75.75 0 0 1 0 1.5h-.75v5.45c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327h-.4c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311c-.327-.642-.327-1.482-.327-3.162v-5.45h-.75a.75.75 0 0 1 0-1.5zm1.5 0a1.25 1.25 0 0 1 2.5 0zm-2.25 1.5h7v5.45c0 .865-.001 1.423-.036 1.848-.033.408-.09.559-.128.633a1.5 1.5 0 0 1-.655.655c-.074.038-.225.095-.633.128-.425.035-.983.036-1.848.036h-.4c-.865 0-1.423-.001-1.848-.036-.408-.033-.559-.09-.633-.128a1.5 1.5 0 0 1-.656-.655c-.037-.074-.094-.225-.127-.633-.035-.425-.036-.983-.036-1.848z"></path></svg>
    ),
    BlockText: () => (
        <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" class="Icon_Icon__uZZKy"><path d="M4 4.75a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-.75h-3.5v8.75h1.25a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.25v-8.75h-3.5v.75a.75.75 0 0 1-1.5 0v-1.5Z"></path></svg>
    ),
    BlockButton: () => (
        <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" class="Icon_Icon__uZZKy"><path d="M4 4.75a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-.75h-3.5v8.75h1.25a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h1.25v-8.75h-3.5v.75a.75.75 0 0 1-1.5 0v-1.5Z"></path></svg>
    ),
    Element: () => (
        <svg viewBox="0 0 20 20" class="Icon_Icon__uZZKy"><path d="M7.25 3.5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5h-5.5Z"></path><path d="M5 6.5a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Z"></path><path fill-rule="evenodd" d="M3.5 10.75a2.75 2.75 0 0 1 2.75-2.75h7.5a2.75 2.75 0 0 1 2.75 2.75v3a2.75 2.75 0 0 1-2.75 2.75h-7.5a2.75 2.75 0 0 1-2.75-2.75v-3Zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v3c0 .69.56 1.25 1.25 1.25h7.5c.69 0 1.25-.56 1.25-1.25v-3c0-.69-.56-1.25-1.25-1.25h-7.5Z"></path></svg>
    ),
    Back: () => (
        <svg viewBox="0 0 20 20" class="Icon_Icon__uZZKy"><path fill-rule="evenodd" d="M5.324 9h5.602c.258 0 .494 0 .692.016.213.018.446.057.676.175.33.168.598.435.765.765.118.23.158.463.175.676.016.198.016.434.016.692v3.352c0 .258 0 .494-.016.692-.018.213-.057.446-.175.676-.167.33-.435.598-.764.765-.23.118-.464.157-.677.175-.198.016-.434.016-.692.016h-5.602c-.258 0-.494 0-.692-.016-.213-.018-.446-.057-.676-.175-.33-.168-.597-.435-.765-.765-.118-.23-.157-.463-.175-.676-.016-.198-.016-.434-.016-.692v-3.352c0-.258 0-.494.016-.692.018-.213.057-.446.175-.676.168-.33.435-.597.765-.765.23-.118.463-.157.676-.175.198-.016.434-.016.692-.016Zm-.693 1.53h.001-.001Zm.002-.001c.01-.003.042-.011.121-.018.13-.01.304-.011.596-.011h5.55c.292 0 .467 0 .596.011.079.007.112.015.12.018.045.023.082.06.105.104.003.01.011.043.018.121.01.13.011.304.011.596v3.3c0 .292 0 .467-.011.596-.007.079-.015.112-.018.12-.023.045-.06.082-.104.105-.01.003-.043.011-.121.018-.13.01-.304.011-.596.011h-5.55c-.292 0-.467 0-.596-.011-.079-.007-.112-.015-.12-.018-.045-.023-.082-.06-.105-.104-.003-.01-.011-.043-.018-.121-.01-.13-.011-.304-.011-.596v-3.3c0-.292 0-.467.011-.596.007-.079.015-.112.018-.12.023-.045.06-.082.104-.105Zm-.103.102v.001-.001Zm0 4.738v-.001.001Zm.1.101h.002-.001Zm6.99 0h-.002.001Zm.1-.1v-.002.001Zm0-4.74v.002-.001Zm-.102-.1h.001-.001Z"></path><path fill-rule="evenodd" d="M17 9.5v-2.5c0-1.519-1.231-2.75-2.75-2.75h-2.94l.72-.72c.293-.293.293-.767 0-1.06-.293-.293-.767-.293-1.06 0l-2 2c-.141.14-.22.331-.22.53s.079.39.22.53l2 2c.293.293.767.293 1.06 0 .293-.293.293-.767 0-1.06l-.72-.72h2.94c.69 0 1.25.56 1.25 1.25v2.5c0 .414.336.75.75.75s.75-.336.75-.75Z"></path></svg>
    )
};

const OutlineLabel = ({ textRef }) => (
    <div className="smind-label">
        <Icons.Layout />
        <span ref={textRef}>Section</span> {/* Dùng thẻ span để chứa Text động */}
    </div>
);

const OutlinePlus = ({ onAdd }) => (
    <div className="smind-plus">
        <div className="smind-plus-item __top">
            <Icons.Plus />
            <div className="smind-buttons">
                <button onClick={() => onAdd('section', 'top')}>Add section</button>
                {/* <button onClick={() => onAdd('template')}>Add template</button> */}
            </div>
        </div>
        <div className="smind-plus-item __bottom">
            <Icons.Plus />
            <div className="smind-buttons">
                <button onClick={() => onAdd('section', 'bottom')}>Add section</button>
                {/* <button onClick={() => onAdd('template')}>Add template</button> */}
            </div>
        </div>
    </div>
);

const OutlineActions = ({ onHide, onRemove, onMoveUp, onMoveDown }) => (
    <div className="smind-actions">
        <div className="__inner">
            <button className="smind-btn __up" onClick={onMoveUp}>
                <div className="smind-tooltip">Move up</div>
                <Icons.MoveUp />
            </button>
            <button className="smind-btn __down" onClick={onMoveDown}>
                <div className="smind-tooltip">Move down</div>
                <Icons.MoveDown />
            </button>
            <button className="smind-btn __view" onClick={onHide}>
                <div className="smind-tooltip">Show/hide</div>
                <Icons.View />
            </button>
            <button className="smind-btn __delete" onClick={onRemove}>
                <div className="smind-tooltip">Remove</div>
                <Icons.Delete />
            </button>
        </div>
    </div>
);

const OutlineLabelBlock = ({ textRef, textSectionRef }) => {
    return (
        <div className="smind-label">
            <div className="smind-sub-label __section">
                <Icons.Layout />
                <span ref={textSectionRef}>Section</span>
            </div>
            <Icons.Block />
            <span ref={textRef}>Block</span>
        </div>
    )
}

const OutlinePlusBlock = ({ onAdd }) => (
    <div className="smind-plus">
        <div className="smind-plus-item __top">
            <Icons.Plus />
            <div className="smind-buttons">
                <button onClick={() => onAdd('block', 'top')}>Add block</button>
            </div>
        </div>
        <div className="smind-plus-item __bottom">
            <Icons.Plus />
            <div className="smind-buttons">
                <button onClick={() => onAdd('block', 'bottom')}>Add block</button>
            </div>
        </div>
    </div>
);

const OutlineActionsBlock = ({ onHide, onRemove }) => (
    <div className="smind-actions">
        <div className="__inner">
            <button className="smind-btn __view" onClick={onHide}>
                <div className="smind-tooltip">Show/hide</div>
                <Icons.View />
            </button>
            <button className="smind-btn __delete" onClick={onRemove}>
                <div className="smind-tooltip">Remove</div>
                <Icons.Delete />
            </button>
        </div>
    </div>
);

const OutlineLabelElement = ({ textRef, textSectionRef }) => {
    return (
        <div className="smind-label">
            <div className="smind-sub-label __section">
                <Icons.Layout />
                <span ref={textSectionRef}>Block</span>
            </div>
            <Icons.Element />
            <span ref={textRef}>Element</span>
        </div>
    )
}

export {
    OutlineLabel,
    OutlinePlus,
    OutlineActions,
    OutlineLabelBlock,
    OutlinePlusBlock,
    OutlineActionsBlock,
    OutlineLabelElement
}